module.exports = __webpack_public_path__ + "img/ics_f_cursor.6f7e5b29.svg";